<!-- <section lottie [options]="options" (animationCreated)="animationCreated($event)"></section> -->
<div style="    position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
  <img alt="" src="./../../../../assets/animations/loader_logo.svg">
</div>
<ng-lottie (animationCreated)="animationCreated($event)" [options]="options"
           style="display:flex;margin:0 auto;width:16%">
</ng-lottie>
